import { formatCurrency } from "@/lib/utils";

import type { RiderPayroll } from "@artisancode/api-types";

export function RiderPayrollSummaryBox({ editing }: { editing: RiderPayroll }) {
  return (
    <div className="grid grid-cols-2 gap-2.5 rounded-lg border bg-muted/20 p-3 sm:grid-cols-4">
      <div>
        <p className="text-xs text-muted-foreground">Hari Kerja</p>
        <p className="font-semibold text-sm">{editing.daysWorked} hari</p>
      </div>
      <div>
        <p className="text-xs text-muted-foreground">Gaji Harian</p>
        <p className="font-semibold text-sm">
          {formatCurrency(editing.dailyWageRate * editing.daysWorked)}
        </p>
      </div>
      <div>
        <p className="text-xs text-muted-foreground">Pendapatan Penjualan</p>
        <p className="font-semibold text-sm">
          {formatCurrency(editing.salesIncomeAmount)}
        </p>
      </div>
      <div>
        <p className="text-xs text-muted-foreground">Bonus Target</p>
        <p className="font-semibold text-sm">
          {formatCurrency(editing.bonusAmount)}
        </p>
      </div>
    </div>
  );
}
